const allReportFieldGroups = [
  'experience',
  'retailer',
  'product',
  'sales',
];

export const getAvailableMetrics = (
  metrics,
  selectedDimensions,
  selectedFilterDimensions,
  selectedMetrics,
) => {
  return getAvailableReportFields(
    metrics,
    selectedDimensions,
    selectedFilterDimensions,
    selectedMetrics,
  );
};

export const getAvailableDimensions = (
  dimensions,
  selectedDimensions,
  selectedFilterDimensions,
  selectedMetrics,
) => {
  return getAvailableReportFields(
    dimensions,
    selectedDimensions,
    selectedFilterDimensions,
    selectedMetrics,
  );
};

export const getAvailableGroups = (reportFields) => {
  return reportFields.reduce((availableGroups, rp) => {
    const intersection = rp.groups.filter(g => availableGroups.indexOf(g) >= 0);

    return intersection.length < availableGroups.length
      ? intersection
      : availableGroups;
  }, allReportFieldGroups);
};

export const getNormalizedMetricValues = (reportFields, reportMetrics = []) => {
  // Some old Reports have outdated metrics keys that have been renamed and aliased.
  // So we need to check for old, aliased metrics and normalize them.
  const metricsAliases = getAvailableReportFieldsAliases(reportFields);
  const normalizedReportMetrics = reportMetrics.map(metric => {
    const aliasedMetric = metricsAliases[metric] && metricsAliases[metric].value;

    return aliasedMetric || metric;
  });

  return normalizedReportMetrics;
};

export const getMetricsValuesByGroup = (metrics, group) => {
  return metrics.reduce((metricsValues, metric) => {
    if (reportFieldGroupsOnlyContains(metric, group)) {
      metricsValues.push(metric.value);
    }

    return metricsValues;
  }, []);
};

export const getAvailableReportFields = (
  reportFields,
  selectedDimensions,
  selectedFilterDimensions,
  selectedMetrics,
) => {
  const selectedReportFields = selectedDimensions
    .concat(selectedFilterDimensions)
    .concat(selectedMetrics);
  const availableGroups = getAvailableGroups(selectedReportFields);

  return reportFields.map(rp => {
    const isAvailable = isReportFieldAvailable(rp, availableGroups);

    return {
      ...rp,
      disabled: !isAvailable,
    };
  });
};

const getAvailableReportFieldsAliases = (reportFields) => {
  return reportFields.reduce((aliasDict, field) => {
    const { aliases = [] } = field;

    aliases.forEach(aliasName => aliasDict[aliasName] = field);

    return aliasDict;
  }, {});
};

const isReportFieldAvailable = (reportField, availableGroups) => {
  return reportField.groups.some(g => availableGroups.indexOf(g) >= 0);
};

const reportFieldGroupsOnlyContains = (reportField, group) => {
  return reportField.groups.length === 1 && reportField.groups[0] === group;
};
